export const fadeIn = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
  transition: {
    duration: 0.6,
    ease: 'easeOut',
  },
  viewport: {
    once: true,
    margin: '-50px',
  },
};

export const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
  transition: {
    duration: 0.6,
    ease: 'easeOut',
  },
  viewport: {
    once: true,
    margin: '-50px',
  },
};

export const fadeInDown = {
  hidden: {
    opacity: 0,
    y: -20,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
  transition: {
    duration: 0.6,
    ease: 'easeOut',
  },
  viewport: {
    once: true,
  },
};

export const slideInLeft = {
  hidden: {
    opacity: 0,
    x: -20,
  },
  visible: {
    opacity: 1,
    x: 0,
  },
  transition: {
    duration: 0.6,
    ease: 'easeOut',
  },
  viewport: {
    once: true,
    margin: '-50px',
  },
};

export const slideInRight = {
  hidden: {
    opacity: 0,
    x: 20,
  },
  visible: {
    opacity: 1,
    x: 0,
  },
  transition: {
    duration: 0.6,
    ease: 'easeOut',
  },
  viewport: {
    once: true,
    margin: '-50px',
  },
};
